export function onlyDistinct(value, index, self) {
  return self.indexOf(value) === index;
}

export function distinctArray(arr) {
  return arr.filter(onlyDistinct);
}
